import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { useAppSelector } from "@/services/store";
import { contactsIsEditSelector } from "@/pages/ContactsPage/slice";
import { FormTextArea } from "@/shared/Components";
import styles from "./styles.module.scss";

export const AdditionalInfo = () => {
  const { t } = useTranslation();

  const { watch } = useFormContext();
  const isEdit = useAppSelector(contactsIsEditSelector);
  return (
    <div
      className={classNames(styles["additional-info"], {
        [styles["additional-info-edit"]]: isEdit,
      })}
    >
      {isEdit ? (
        <FormTextArea placeholder={t("common.about")} name="additionalInformation" />
      ) : (
        watch("additionalInformation")
      )}
    </div>
  );
};
